/**
 * User Role Enum
 * Centralized definition of all user roles in the application
 */
export const USER_ROLES = {
    USER: 'user',
    ADMIN: 'admin'
};

/**
 * Get user role from userData object
 * Handles both string and object role formats
 * @param {Object} userData - User data object from Redux
 * @returns {string|null} - Role name or null if not found
 */
export const getUserRole = (userData) => {
    if (!userData) return null;

    // Handle string format: userData.role = 'user'
    if (typeof userData.role === 'string') {
        return userData.role;
    }

    // Handle object format: userData.role = { name: 'user' }
    if (typeof userData.role === 'object' && userData.role?.name) {
        return userData.role.name;
    }

    return null;
};

/**
 * Check if user has one of the allowed roles
 * @param {Object} userData - User data object from Redux
 * @param {Array<string>} allowedRoles - Array of allowed role names
 * @returns {boolean} - True if user has one of the allowed roles
 */
export const hasRole = (userData, allowedRoles = []) => {
    const userRole = getUserRole(userData);
    if (!userRole) return false;

    return allowedRoles.includes(userRole);
};